"use client";

import { c as _c } from "react/compiler-runtime";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";
import { getStripePublishableKeyOrNull, isPaymentProviderPubliclyEnabled } from "@llmgateway/shared";
import type { Stripe } from "@stripe/stripe-js";
let stripePromise: Promise<Stripe | null> | null = null;
const stripePublishableKey = isPaymentProviderPubliclyEnabled("stripe", {
  NEXT_PUBLIC_PAYMENT_PROVIDERS: process.env.NEXT_PUBLIC_PAYMENT_PROVIDERS
}) ? getStripePublishableKeyOrNull(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY) : null;
function getStripePromise() {
  if (!stripePublishableKey) {
    return null;
  }
  stripePromise ??= loadStripe(stripePublishableKey);
  return stripePromise;
}
export function useStripe() {
  const $ = _c(6);
  const [stripe, setStripe] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const enabled = Boolean(stripePublishableKey);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const promise = getStripePromise();
      if (!promise) {
        setStripe(null);
        setError(null);
        setIsLoading(false);
        return;
      }
      Promise.resolve().then(() => promise).then(stripeInstance => {
        setStripe(stripeInstance);
        setIsLoading(false);
      }).catch(err => {
        setError(err);
        setIsLoading(false);
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== error || $[3] !== isLoading || $[4] !== stripe) {
    t2 = {
      stripe,
      isLoading,
      error,
      enabled
    };
    $[2] = error;
    $[3] = isLoading;
    $[4] = stripe;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function loadStripeNow() {
  return getStripePromise();
}